import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PagesAtterrissageService {

  constructor(private http: HttpClient) {
  }

  createPageAtterissage(idOuvrage, $nombre): Observable<Object> {

    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(`${environment.apiUrl}/api/page_atterrissage/create`, {idOuvrage: idOuvrage, nombre: $nombre}).pipe(
      map(response => {

        return response;
      })
    );
  }

  deletePageAtterissage(idPage): Observable<Object> {

    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(`${environment.apiUrl}/api/page_atterrissage/delete`, {id: idPage}).pipe(
      map(response => {

        return response;
      })
    );
  }
}
